import { useState } from 'react'
import { motion } from 'framer-motion'
import AtomBackground from './Atombackground'
import Reveal from './Reveal'

const features = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="7" stroke="#C9A84C" strokeWidth="1"/>
        <circle cx="10" cy="10" r="3" stroke="#C9A84C" strokeWidth="1"/>
        <line x1="10" y1="3" x2="10" y2="1" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <line x1="10" y1="17" x2="10" y2="19" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <line x1="3" y1="10" x2="1" y2="10" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <line x1="17" y1="10" x2="19" y2="10" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Sesión estratégica inicial',
    desc: 'Diagnóstico de tu situación y diseño de un plan de trabajo personalizado.',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect x="2" y="3" width="16" height="14" rx="1.5" stroke="#C9A84C" strokeWidth="1"/>
        <line x1="2" y1="7" x2="18" y2="7" stroke="#C9A84C" strokeWidth="1"/>
        <line x1="6" y1="1" x2="6" y2="5" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <line x1="14" y1="1" x2="14" y2="5" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <rect x="6" y="10" width="3" height="3" rx="0.5" fill="#C9A84C" opacity="0.6"/>
        <rect x="11" y="10" width="3" height="3" rx="0.5" stroke="#C9A84C" strokeWidth="0.8" opacity="0.4"/>
      </svg>
    ),
    title: 'Sesiones semanales de 60 min',
    desc: 'Seguimiento continuo, revisión de avances y ajuste de estrategia en tiempo real.',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3 4h14a1 1 0 011 1v8a1 1 0 01-1 1H5l-3 3V5a1 1 0 011-1z" stroke="#C9A84C" strokeWidth="1"/>
        <line x1="7" y1="8" x2="13" y2="8" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
        <line x1="7" y1="11" x2="11" y2="11" stroke="#C9A84C" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Acceso directo por WhatsApp',
    desc: 'Soporte entre sesiones para consultas urgentes y dudas puntuales.',
  },
]

const areaOptions = [
  'Preparación MIR / Residencias',
  'Desarrollo profesional',
  'Investigación médica',
  'Otro',
]

function FormField({ label, children }) {
  return (
    <div className="flex flex-col gap-2">
      <label
        className="font-display font-semibold text-[10px] tracking-[0.14em] uppercase"
        style={{ color: 'var(--ink-3)' }}
      >
        {label}
      </label>
      {children}
    </div>
  )
}

const inputStyle = {
  background: 'var(--bg-2)',
  border: '1px solid var(--line)',
  color: 'var(--ink)',
  padding: '12px 16px',
  fontSize: '14px',
  fontFamily: 'Plus Jakarta Sans, sans-serif',
  outline: 'none',
  width: '100%',
  transition: 'border-color 0.2s',
}

export default function Mentorias() {
  const [form, setForm] = useState({ nombre: '', email: '', wa: '', area: '', msg: '' })
  const [sent, setSent] = useState(false)

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }))

  const handleSubmit = (e) => {
    e.preventDefault()
    setSent(true)
  }

  return (
    <section
      id="mentorias"
      className="relative overflow-hidden"
      style={{ padding: '120px 5vw', background: 'var(--bg-2)' }}
    >
      <AtomBackground />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        {/* Left: info */}
        <Reveal>
          <div className="section-label">Mentorías 1 a 1</div>
          <h2
            className="font-display font-black leading-[1.04] tracking-[-0.02em] mb-5"
            style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', color: 'var(--ink)' }}
          >
            Atención<br />
            <em className="not-italic" style={{ color: 'var(--gold)' }}>personalizada</em>
            <br />para tu caso.
          </h2>
          <p
            className="font-body font-light text-[15px] leading-[1.85] mb-10"
            style={{ color: 'var(--ink-2)' }}
          >
            Ingresos, nivelatorios, temas complejos y acompañamiento académico individual —
            diseñado específicamente para vos.
          </p>

          {/* Features */}
          <div
            className="flex flex-col"
            style={{ borderTop: '1px solid var(--line)' }}
          >
            {features.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
                className="flex gap-6 py-8"
                style={{ borderBottom: '1px solid var(--line)' }}
              >
                <div
                  className="w-11 h-11 shrink-0 flex items-center justify-center"
                  style={{ border: '1px solid var(--line)' }}
                >
                  {f.icon}
                </div>
                <div>
                  <div
                    className="font-display font-bold text-[15px] mb-1.5"
                    style={{ color: 'var(--ink)' }}
                  >
                    {f.title}
                  </div>
                  <p
                    className="font-body font-light text-[13px] leading-[1.75]"
                    style={{ color: 'var(--ink-2)' }}
                  >
                    {f.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </Reveal>

        {/* Right: form */}
        <Reveal delay={0.15}>
          <div
            className="p-10 lg:p-12"
            style={{ background: 'var(--bg-3)', border: '1px solid var(--line)' }}
          >
            <h3
              className="font-display font-black text-[20px] tracking-[-0.01em] mb-8"
              style={{ color: 'var(--ink)' }}
            >
              Solicitar mentoría
            </h3>

            {sent ? (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex flex-col items-center justify-center py-16 gap-4"
              >
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center"
                  style={{ border: '1px solid var(--gold)' }}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 10l4 4 8-8" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <p className="font-display font-semibold text-[14px]" style={{ color: 'var(--ink-2)' }}>
                  Solicitud enviada. Te contactamos pronto.
                </p>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <FormField label="Nombre">
                    <input
                      type="text"
                      placeholder="Tu nombre completo"
                      value={form.nombre}
                      onChange={set('nombre')}
                      required
                      style={inputStyle}
                      onFocus={e => e.target.style.borderColor = 'rgba(201,168,76,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'var(--line)'}
                    />
                  </FormField>
                  <FormField label="Email">
                    <input
                      type="email"
                      placeholder="correo@ejemplo.com"
                      value={form.email}
                      onChange={set('email')}
                      required
                      style={inputStyle}
                      onFocus={e => e.target.style.borderColor = 'rgba(201,168,76,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'var(--line)'}
                    />
                  </FormField>
                </div>
                <FormField label="WhatsApp">
                  <input
                    type="text"
                    placeholder="+54 9 ..."
                    value={form.wa}
                    onChange={set('wa')}
                    style={inputStyle}
                    onFocus={e => e.target.style.borderColor = 'rgba(201,168,76,0.5)'}
                    onBlur={e => e.target.style.borderColor = 'var(--line)'}
                  />
                </FormField>
                <FormField label="Área de interés">
                  <select
                    value={form.area}
                    onChange={set('area')}
                    required
                    style={{ ...inputStyle, appearance: 'none', cursor: 'pointer' }}
                    onFocus={e => e.target.style.borderColor = 'rgba(201,168,76,0.5)'}
                    onBlur={e => e.target.style.borderColor = 'var(--line)'}
                  >
                    <option value="" disabled>Seleccionar</option>
                    {areaOptions.map(o => (
                      <option key={o} value={o} style={{ background: 'var(--bg-3)' }}>{o}</option>
                    ))}
                  </select>
                </FormField>
                <FormField label="Mensaje">
                  <textarea
                    rows={4}
                    placeholder="Contame brevemente qué estás buscando…"
                    value={form.msg}
                    onChange={set('msg')}
                    style={{ ...inputStyle, resize: 'none' }}
                    onFocus={e => e.target.style.borderColor = 'rgba(201,168,76,0.5)'}
                    onBlur={e => e.target.style.borderColor = 'var(--line)'}
                  />
                </FormField>

                <motion.button
                  type="submit"
                  className="w-full font-display font-black text-[12px] tracking-[0.1em] uppercase py-4 mt-2"
                  style={{ background: 'var(--gold)', color: '#000' }}
                  whileHover={{ backgroundColor: '#E2C47A' }}
                  whileTap={{ scale: 0.98 }}
                >
                  Enviar solicitud
                </motion.button>

                <div className="flex items-center justify-center gap-2.5 mt-3 cursor-pointer group">
                  <div className="w-2 h-2 rounded-full shrink-0" style={{ background: '#25D366' }} />
                  <span
                    className="font-body text-[12px] tracking-[0.04em] transition-colors duration-200"
                    style={{ color: 'var(--ink-3)' }}
                  >
                    Contactar directamente por WhatsApp
                  </span>
                </div>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  )
}